import React from 'react';

const PageNotFound: React.FC = () => <p>The page you are looking for was not found.</p>;

export default PageNotFound;
